import { get } from 'lodash';
import { connect } from 'react-redux';

const mapStateToProps = state => ({ selectedPatientId: get(state, 'query.all.patient_id') });
export default Component => connect(mapStateToProps)(Component);
